var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"mb-4",attrs:{"elevation":"4"}},[_c('v-card-title',[_vm._v(" Change Password ")])],1),_c('v-card',[_c('v-col',[_c('change-password',{attrs:{"show-old-password-field":!_vm.currentUser.isAdmin},on:{"onSubmit":_vm.changeUserPassword}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }